export default {
      id: "ic-display-inline-usage",
      viewBox: "0 0 78 36",
      url: "../dist/images/" + "sprite.svg#ic-display-inline-usage",
      toString: function () {
        return this.url;
      }
    }